/// Appelé uniquement sur la page d'accueil des listes mariages, pacs et cadeaux
class Participation extends ListeMariage {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize(idFormulaire) {
		let self = this;
		super.initialize();

		const form = new Formulaire(settings);
		form.initialize(idFormulaire);

		/// Indicatif téléphonique
		form.indicatifTelephonique();

		/// On retire la value si elle vaut 0
		document.addEventListener('DOMContentLoaded', function () {
			document.getElementById('Montant').value === '0' && document.getElementById('Montant').removeAttribute('value');
		});
	}
}